module.exports = __webpack_public_path__ + "img/op_img-card-2.968bcc2.jpg";